/**
 * Language configuration for Symphony Browser
 * Defines available languages and default language settings
 */

// TODO: Consider refactoring into a GraphQL query
/**
 * List of available languages in the application
 * @type {Array<{code: string, name: string}>}
 */
export const AVAILABLE_LANGUAGES = [
  { code: 'eng', name: 'English' },
  { code: 'fra', name: 'French' },
  { code: 'spa', name: 'Spanish' },
  { code: 'deu', name: 'German' },
  { code: 'por', name: 'Portuguese' },
  { code: 'rus', name: 'Russian' },
  { code: 'zho', name: 'Chinese' },
  { code: 'ara', name: 'Arabic' },
  { code: 'hin', name: 'Hindi' },
];

/**
 * Default language code
 * Used as fallback when requested language is unavailable
 * @type {string}
 */
export const DEFAULT_LANGUAGE = 'eng';

/**
 * Get language name by code
 * @param {string} code - ISO 639-3 language code
 * @returns {string|null} Language name or null if not found
 */
export function getLanguageName(code) {
  const language = AVAILABLE_LANGUAGES.find(lang => lang.code === code);
  return language ? language.name : null;
}

/**
 * Check if language code is valid
 * @param {string} code - ISO 639-3 language code
 * @returns {boolean} True if language is available
 */
export function isValidLanguage(code) {
  return AVAILABLE_LANGUAGES.some(lang => lang.code === code);
}
